import AnalyticsService from "@emcd-shared/analytics-service";

export function logErrorToSentry(hooksName, errorType, error) {
  AnalyticsService.addBreadcrumb(hooksName, errorType);
  if (error.response) {
    AnalyticsService.log(error.response.status);
    AnalyticsService.log(JSON.stringify(error.response.data));
    AnalyticsService.log(JSON.stringify(error.response.headers));
  }
  if (error.request) {
    AnalyticsService.log(error.request.status);
    AnalyticsService.log(JSON.stringify(error.request.data));
    AnalyticsService.log(JSON.stringify(error.request.headers));
  }
  AnalyticsService.error(error);
}
